import React from 'react';

const FullScreen = () => {
  const handleFullScreen = () => {
    const element = document.documentElement;

    if (document.fullscreenElement) {
      // If the page is currently in fullscreen, exit fullscreen
      document.exitFullscreen();
    } else {
      // If the page is not in fullscreen, request fullscreen
      element.requestFullscreen().catch((err) => {
        console.error('Error attempting to enable fullscreen:', err);
      });
    }
  };

  return (
    <button onClick={handleFullScreen}>
      Toggle Full Screen
    </button>
  );
};

export default FullScreen;
